import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./image-object.module.css";
var _alt;
export var ImageObject = function(param) {
    var image = param.image;
    return /*#__PURE__*/ _jsx("img", {
        src: image.filename,
        alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : "",
        className: styles.image
    });
};
